import { ColumnType } from "antd/lib/table";
import { compact } from "lodash";
import { EMPTY } from "constants/common";
import { AiccCanDoStatement, AiccCanDoStatementUploadRow } from "types/model/aiccLearningAssets";
import getActionColumn from "../getActionColumn";

export const previewColumns: ColumnType<AiccCanDoStatementUploadRow>[] = [
  { title: "Fluency Level", dataIndex: "fluencyLevel", key: "fluencyLevel", width: 140 },
  { title: "Statement", dataIndex: "statement", key: "statement" },
];

interface Options {
  canManage: boolean;
  canDelete: boolean;
  isActionDisabled: boolean;
  onEdit: (record: AiccCanDoStatement) => void;
  onDelete: (record: AiccCanDoStatement) => void;
}

const getColumns = ({ canManage, canDelete, isActionDisabled, onEdit, onDelete }: Options) =>
  compact<ColumnType<AiccCanDoStatement>>([
    {
      title: "Fluency Level",
      dataIndex: "fluencyLevel",
      key: "fluencyLevel",
      width: 140,
      render: (fluencyLevel) => fluencyLevel || EMPTY,
    },
    {
      title: "Statement",
      dataIndex: "statement",
      key: "statement",
      render: (statement) => statement || EMPTY,
    },
    canManage && getActionColumn<AiccCanDoStatement>({ canDelete, isDisabled: isActionDisabled, onEdit, onDelete }),
  ]);

export default getColumns;
